import { useOrderState } from './useOrderState'
import { DEFAULT_FLOW_NAME } from '../utils/getFlow'
import { useMemo } from 'react'

const useFlowName = () => {
  const items = useOrderState((s) => s.order.items)
  const activeItemId = useOrderState((s) => s.order.activeItemId)
  const activeItem = useMemo(
    () => items.find((i) => i.id === activeItemId),
    [items, activeItemId]
  )
  return activeItem?.flowName || DEFAULT_FLOW_NAME
}

export default useFlowName
